export const WEEK_LIST_REQUEST = 'WEEK_LIST_REQUEST'
export const WEEK_LIST_SUCCESS = 'WEEK_LIST_SUCCESS'
export const WEEK_LIST_FAIL = 'WEEK_LIST_FAIL'

export const WEEK_UPDATE_REQUEST = 'WEEK_UPDATE_REQUEST'
export const WEEK_UPDATE_SUCCESS = 'WEEK_UPDATE_SUCCESS'
export const WEEK_UPDATE_FAIL = 'WEEK_UPDATE_FAIL'
